import {useId} from 'react';
import {ShieldCheck, Code2, UserRound, CalendarCheck} from 'lucide-react';

// Illustrates the coordination contract; these are not live plan events.
const trail = [
  {actor: 'Pabs', Icon: ShieldCheck, title: 'I reviewed the setup experience.', detail: 'Recovery and keyboard issues need attention.', decision: 'Revise this version.'},
  {actor: 'Pabs', Icon: ShieldCheck, title: 'I prepared the correction brief.', detail: 'Keep the existing flow and design system.', decision: 'Confirm the correction scope.'},
  {actor: 'Connected builder', Icon: Code2, title: 'I returned the corrected version.', detail: 'Updated artifact, screenshots and checks attached.'},
  {actor: 'Pabs', Icon: ShieldCheck, title: 'I reviewed the returned evidence.', detail: 'Findings and missing checks stay visible.', decision: 'Accept this version.'},
  {actor: 'Pabs', Icon: CalendarCheck, title: 'I scheduled a delivery check.', detail: 'Check connected sources against the agreed experience.'},
];

export default function DesignAuthorityTrailPreview({label}) {
  const captionId = useId();
  return <figure className="design-authority-trail" role="img" aria-label={label} aria-describedby={captionId}>
    <div className="design-authority-trail-header">
      <strong><ShieldCheck size={18} aria-hidden="true"/> Design Authority</strong>
      <span>Example work trail</span>
    </div>
    <p className="design-authority-trail-scope">First-project setup, submitted by a connected builder</p>
    <ol>
      {trail.map(({actor, Icon, title, detail, decision}) => <li key={title} data-actor={actor === 'Pabs' ? 'pabs' : 'builder'}>
        <span className="design-authority-trail-avatar"><Icon size={16} aria-hidden="true"/></span>
        <div className="design-authority-trail-event">
          <span className="design-authority-trail-actor">{actor}</span>
          <strong>{title}</strong>
          <p>{detail}</p>
          {decision && <div className="design-authority-trail-decision"><UserRound size={13} aria-hidden="true"/><span><b>Your call:</b> {decision}</span></div>}
        </div>
      </li>)}
    </ol>
    <figcaption id={captionId}>Illustrative workflow with a connected builder, human decisions and a scheduled follow-up.<span className="sr-only"> Pabs reviews setup and you decide to revise. Pabs prepares a correction brief and you confirm its scope. The builder returns evidence. Pabs reviews it; after you accept this version, Pabs schedules a delivery check.</span></figcaption>
  </figure>;
}
